// extracted by mini-css-extract-plugin
module.exports = {"logo":"PageHeader_logo__3tw3v","vilhempNav":"PageHeader_vilhempNav__2env6","facebook":"PageHeader_facebook__1dDFy","navItem":"PageHeader_navItem__pduu_"};